import React from 'react';

const WagonAutoselectionTariffDxCell: React.FC<any> = (props) => {
  return <span>{props.data.isTariffCalculated ? props.value : ''}</span>;
};

export default WagonAutoselectionTariffDxCell;
